import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import {
  SurveyDialogProps,
  TAdmissionCheckListDefaultValues,
} from '../../type';
import { updateMedicalRecords } from 'apis/survey';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import Signature from './Signature';
import EducationList from './EducationList';

const AdmissionCheckList = (
  props: SurveyDialogProps<TAdmissionCheckListDefaultValues>
) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TAdmissionCheckListDefaultValues) => {
    const {
      education_list,

      date,
      name,
      sig,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      admission_check_list: {
        education_list: JSON.stringify(education_list),

        date,
        name,
        sig,
      },
    };

    // console.log(request);

    updateMedicalRecords(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('Saved successfully');
      })
      .catch(e => {
        onFail('Failed to save', e);
        // console.log(e);
      });
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        入院檢查清單
        <br /> - Testing -
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <EducationList {...formProps} />
        <Signature {...formProps} />
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default AdmissionCheckList;
